<template>
  <carousel
    class="carousel-galery"
    ref="carouselSelector"
    :navigationEnabled="true"
    :per-page="1"
    :pagination-enabled="false"
    :loop="true"
    :autoplay="true"
    :autoplay-timeout="5000"
    navigationNextLabel='<img   class="pass__banner" src="img/direita.png" />'
    navigationPrevLabel='<img  class="pass__banner" src="img/esquerda.png" />'
  >
    <slide v-for="(item, index) in items" :key="index">
      <div class="banner__image"
        :style="'background-image: url(' + item.image + ')'"
      ></div>
    </slide>
  </carousel>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props:["items"],
  data() {
    return {
      width: screen.width,
      banner1: "http://localhost/img/foto-evento.png",
      banner2: "http://localhost/img/descrip.png",
      banner3: "http://localhost/img/description.png",
    };
  },
  components: {
    Carousel,
    Slide,
  },
  methods: {
    navigateTo(index) {
      this.slider = index;
      this.$refs.carouselSelector.goToPage(index);
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs["carouselSelector"].onResize();
      this.$refs["carouselSelector"].goToPage(0);
    }, 200);
  },
};
</script>
<style lang="scss">
.carousel-galery {
  width: 100%;
  height: 85vh;
  margin: 0 auto;
  margin-top: -40px !important;
  @media (min-width: 1500px) {
    margin-top: -50px !important;
    height: 100vh;
    width: 100%;
  }
  @media (max-width: 996px) {
    width: 80%;
  }
  @media (max-width: 500px) {
    width: 350px;
    height: 280px;
    margin-bottom: 100px;
  }
  @media (max-width: 400px) {
    width: 250px;
    height: 180px;
    margin-bottom: 100px;
  }

  .banner__image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 800px;
    height: 600px;
    margin: 0 auto;
    @media (min-width: 1500px) {
      width: 100%;
      height: 700px;
    }
    @media (max-width: 996px) {
      width: 600px;
      height: 400px;
    }
    @media (max-width: 750px) {
      width: 500px;
      height: 300px;
    }
    @media (max-width: 600px) {
      width: 400px;
      height: 300px;
    }
    @media (max-width: 500px) {
      width: 350px;
      height: 280px;
    }
    @media (max-width: 400px) {
      width: 250px;
      height: 180px;
    }
  }
}

.pass__banner {
  z-index: 3;
  @media (min-width: 1500px){
    margin-left: 50px;
    margin-right: 50px;
    margin-top: -200px;
  }
  @media (max-width: 996px) {
    max-width: 50px;
    max-height: 50px;
  }
  @media (max-width: 500px) {
    max-width: 30px !important;
    max-height: 30px !important;
  }
}
.VueCarousel-navigation-button, .VueCarousel-navigation-next, .VueCarousel-navigation-prev{
  z-index: 10;
}
</style>